import { computed, effect, inject, Injectable, signal } from '@angular/core'
import { Role } from '../models/auth.model'
import { PermissionService } from './permission.service'
import { CategoryService } from './category.service'

@Injectable({ providedIn: 'root' })
export class RoleService {
  public readonly roles: { label: string, value: Role, selectable: boolean }[] = [
    { label: 'Editor', value: 'EDITOR', selectable: true },
    { label: 'View', value: 'VIEW', selectable: true },
    { label: 'Redakteur', value: 'REDACTEUR', selectable: false },
    { label: 'Admin', value: 'ADMIN', selectable: false }
  ]
  public readonly activeRole = signal<Role | null>(null)
  private readonly permissionService = inject(PermissionService)
  private readonly categoryService = inject(CategoryService)
  public readonly availableRoles = computed(() => {
    const activeCat = this.categoryService.activeCategory()
    if (activeCat === null) {
      return []
    }

    return this.roles.filter(role => {
      switch (role.value) {
        case 'EDITOR':
          return this.permissionService.canEdit(activeCat)
        case 'VIEW':
          return this.permissionService.canView(activeCat) && !this.permissionService.canEdit(activeCat)
        case 'REDACTEUR':
          return this.permissionService.hasRedactRights()
        case 'ADMIN':
          return this.permissionService.hasAdminRights()
        default:
          return false
      }
    })
  })

  constructor() {
    effect(() => {
      const available = this.availableRoles()
      const firstSelectable = available.find(r => r.selectable)

      if (firstSelectable) {
        this.activeRole.set(firstSelectable.value)
      } else {
        // If no selectable roles are available, but there are roles (like just Admin),
        // we might want to keep it null or set it to something.
        this.activeRole.set(null)
      }
    })
  }

  public setRole(role: Role): void {
    this.activeRole.set(role)
  }
}
